const nasobilkaSesti = () => {
	return [
		{
			id: 1,
			priklad: '2 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '12',
				},
				{
					id: 2,
					moznost: '6',
				},
				{
					id: 3,
					moznost: '18',
				},
				{
					id: 4,
					moznost: '24',
				},
			],
			vysledek: '12',
		},
		{
			id: 2,
			priklad: '4 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '18',
				},
				{
					id: 2,
					moznost: '24',
				},
				{
					id: 3,
					moznost: '12',
				},
				{
					id: 4,
					moznost: '30',
				},
			],
			vysledek: '24',
		},
		{
			id: 3,
			priklad: '3 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '12',
				},
				{
					id: 2,
					moznost: '18',
				},
				{
					id: 3,
					moznost: '24',
				},
				{
					id: 4,
					moznost: '30',
				},
			],
			vysledek: '18',
		},
		{
			id: 4,
			priklad: '9 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '60',
				},
				{
					id: 2,
					moznost: '42',
				},
				{
					id: 3,
					moznost: '54',
				},
				{
					id: 4,
					moznost: '48',
				},
			],
			vysledek: '54',
		},
		{
			id: 5,
			priklad: '6 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '42',
				},
				{
					id: 2,
					moznost: '36',
				},
				{
					id: 3,
					moznost: '24',
				},
				{
					id: 4,
					moznost: '30',
				},
			],
			vysledek: '30',
		},
		{
			id: 6,
			priklad: '6 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '42',
				},
				{
					id: 2,
					moznost: '36',
				},
				{
					id: 3,
					moznost: '48',
				},
				{
					id: 4,
					moznost: '54',
				},
			],
			vysledek: '48',
		},
		{
			id: 7,
			priklad: '10 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '60',
				},
				{
					id: 2,
					moznost: '54',
				},
				{
					id: 3,
					moznost: '48',
				},
				{
					id: 4,
					moznost: '42',
				},
			],
			vysledek: '60',
		},
		{
			id: 8,
			priklad: '6 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '30',
				},
				{
					id: 2,
					moznost: '36',
				},
				{
					id: 3,
					moznost: '42',
				},
				{
					id: 4,
					moznost: '48',
				},
			],
			vysledek: '36',
		},
		{
			id: 9,
			priklad: '7 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '36',
				},
				{
					id: 2,
					moznost: '48',
				},
				{
					id: 3,
					moznost: '42',
				},
				{
					id: 4,
					moznost: '30',
				},
			],
			vysledek: '42',
		},
		{
			id: 10,
			priklad: '6 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '36',
				},
				{
					id: 2,
					moznost: '48',
				},
				{
					id: 3,
					moznost: '42',
				},
				{
					id: 4,
					moznost: '54',
				},
			],
			vysledek: '42',
		},
		{
			id: 11,
			priklad: '60 : 6',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '10',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '10',
		},
		{
			id: 12,
			priklad: '36 : 6',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '6',
		},
		{
			id: 13,
			priklad: '6 : 6',
			moznosti: [
				{
					id: 1,
					moznost: '3',
				},
				{
					id: 2,
					moznost: '2',
				},
				{
					id: 3,
					moznost: '1',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '1',
		},
		{
			id: 14,
			priklad: '42 : 6',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '8',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '7',
		},
		{
			id: 15,
			priklad: '54 : 6',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '9',
				},
			],
			vysledek: '9',
		},
		{
			id: 16,
			priklad: '48 : 6',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '8',
				},
				{
					id: 4,
					moznost: '9',
				},
			],
			vysledek: '8',
		},
		{
			id: 17,
			priklad: '24 : 6',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '4',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '3',
				},
			],
			vysledek: '4',
		},
		{
			id: 18,
			priklad: '30 : 6',
			moznosti: [
				{
					id: 1,
					moznost: '5',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '5',
		},
		{
			id: 19,
			priklad: '54 : 6',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '9',
				},
			],
			vysledek: '9',
		},
		{
			id: 20,
			priklad: '18 : 6',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '3',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '3',
		},
		{
			id: 21,
			priklad: '6 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '12',
				},
				{
					id: 3,
					moznost: '18',
				},
				{
					id: 4,
					moznost: '24',
				},
			],
			vysledek: '12',
		},
		{
			id: 22,
			priklad: '6 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '24',
				},
				{
					id: 2,
					moznost: '12',
				},
				{
					id: 3,
					moznost: '18',
				},
				{
					id: 4,
					moznost: '30',
				},
			],
			vysledek: '24',
		},
		{
			id: 23,
			priklad: '6 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '24',
				},
				{
					id: 2,
					moznost: '18',
				},
				{
					id: 3,
					moznost: '12',
				},
				{
					id: 4,
					moznost: '30',
				},
			],
			vysledek: '18',
		},
		{
			id: 24,
			priklad: '6 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '45',
				},
				{
					id: 2,
					moznost: '54',
				},
				{
					id: 3,
					moznost: '36',
				},
				{
					id: 4,
					moznost: '63',
				},
			],
			vysledek: '54',
		},
		{
			id: 25,
			priklad: '5 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '48',
				},
				{
					id: 2,
					moznost: '42',
				},
				{
					id: 3,
					moznost: '30',
				},
				{
					id: 4,
					moznost: '36',
				},
			],
			vysledek: '30',
		},
		{
			id: 26,
			priklad: '8 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '48',
				},
				{
					id: 2,
					moznost: '42',
				},
				{
					id: 3,
					moznost: '56',
				},
				{
					id: 4,
					moznost: '36',
				},
			],
			vysledek: '48',
		},
	];
};

export default nasobilkaSesti;
